import Head from "next/head";
import { useRouter } from "next/router";
import { getGithubUserInfo } from "../../server/tickets";
import { getTicketImageUrl } from "../../utils";
import TicketView from "../../components/tickets/TicketView";
import Layout from "../../components/ui/Layout";
import { TICKET_META_DESCRIPTION } from "../../data/constants";

export default function Tickets({ githubUserInfo }) {
  const router = useRouter();
  const { githubName, githubUserName } = githubUserInfo;
  const name = githubName || githubUserName;
  const title = `${name}'s React Day Ticket`;
  const url = `${process.env.NEXT_PUBLIC_SITE_ORIGIN}${router.asPath}`;
  const ticketImageUrl = getTicketImageUrl(githubUserName);
  const description = TICKET_META_DESCRIPTION;
  return (
    <Layout className="bg-gray-100">
      <Head>
        <title>React Day Bangalore</title>
        <meta property="og:title" content={title} />
        <meta property="og:url" content={url} />
        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@ReactDayIn" />
        <meta name="twitter:creator" content="@ReactDayIn" />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta name="twitter:image" content={ticketImageUrl} />
        <meta property="og:image" content={ticketImageUrl} />
      </Head>
      <div className="min-h-screen flex flex-col">
        <div className="flex-1">
          <TicketView {...githubUserInfo} />
        </div>
      </div>
    </Layout>
  );
}

export async function getStaticProps({ params: { username } }) {
  const githubUserInfo = await getGithubUserInfo(username);
  console.log(githubUserInfo);

  if (!githubUserInfo) {
    return {
      props: {
        githubUserInfo: {
          githubUserName: "username",
          githubName: "Your Name",
        },
      },
    };
  }
  return {
    props: {
      githubUserInfo,
    },
    revalidate: 5,
  };
}

export async function getStaticPaths() {
  return Promise.resolve({
    paths: [],
    fallback: "blocking",
  });
}
